<template>
    <div>
        <div>
            <h2 class="d-inline-block">Employee Dashboard</h2>
            <el-date-picker
                @change="onChangeIssue"
                class="d-inline"
                type="month"
                v-model="issue"
            >
            </el-date-picker>
        </div>
        <el-table :data="paginatedData" row-key="user_id" v-loading="loading">
            <el-table-column label="Name" prop="user_name"></el-table-column>
            <el-table-column label="Calendar Points" prop="calendar_points">
                <template slot-scope="{ row }">
                    {{ row.calendar_points }}
                </template>
            </el-table-column>
            <el-table-column
                label="Newsletter Points"
                prop="newsletter_points"
            ></el-table-column>
            <el-table-column label="Total Points" prop="total_points">
                <template slot-scope="{ row }">
                    {{ row.calendar_points + row.newsletter_points }}
                </template>
            </el-table-column>
        </el-table>
        <div class="mt-10" v-if="pageCount >= 1">
            <el-pagination
                :current-page.sync="pagination.current_page"
                :page-size="pagination.per_page"
                :total="dataCount"
                @current-change="changePage"
                @size-change="handleSizeChange"
                background
                class="pull-right"
                v-if="pagination && pageCount > 1"
            >
            </el-pagination>
            <div class="clearfix"></div>
        </div>
        <div>
            <h2 class="d-inline-block">Order Statistics</h2>
            <div><LineChart /></div>
        </div>
        <div class="container">
            <h2 class="d-inline-block">Theme Statistics</h2>
            <div>
                <el-table
                    v-loading="loading"
                    :data="themeData"
                    style="width: 100%"
                >
                    <el-table-column prop="name" label="Theme Name">
                    </el-table-column>
                    <el-table-column prop="month" label="Month">
                    </el-table-column>
                    <el-table-column prop="count" label="# of times ordered">
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import LineChart from "@/components/charts/LineChart";
import auth from "@/mixins/auth";
import paginator from "@/mixins/frontend-paginator";

export default {
    components: {
        LineChart
    },
    mixins: [paginator, auth],
    data() {
        return {
            points: [],
            issue: null,
            dataKey: "points",
            loading: false,
            themeData: [],
            orderData: []
        };
    },
    created() {
        this.issue = moment().toDate();
        this.getPoints();
        this.getThemeStats();
        this.getOrderStats();
    },
    methods: {
        getOrderStats() {
            this.loading = true;
            axios
                .get(`/web-api/order-statistics`, {
                    params: {
                        year: this.issue.getFullYear(),
                        month: this.issue.getMonth() + 1
                    }
                })
                .then((response) => {
                    this.orderData = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getThemeStats() {
            this.loading = true;
            axios
                .get(`/web-api/theme-statistics`, {
                    params: {
                        year: this.issue.getFullYear(),
                        month: this.issue.getMonth() + 1
                    }
                })
                .then((response) => {
                    this.themeData = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getPoints() {
            this.loading = true;
            axios
                .get(`/web-api/order/dashboard/points`, {
                    params: {
                        year: this.issue.getFullYear(),
                        month: this.issue.getMonth() + 1
                    }
                })
                .then((response) => {
                    this.points = response.data.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onChangeIssue(value) {
            this.getPoints();
            this.getThemeStats();
            this.getOrderStats();
        }
    }
};
</script>

<style scoped></style>
